import { can } from '@/lib/permissions';
import { useAuthStore } from '@/store/authStore';

/**
 * Droits de l'utilisateur courant sur un module donné.
 * - ADMIN (propriétaire) : tout vrai, et seul à pouvoir supprimer.
 * - Autres : selon les permissions accordées (la suppression n'est jamais accordée).
 */
export function usePerms(module: string) {
  const user = useAuthStore((s) => s.user);
  const isAdmin = user?.role === 'ADMIN';
  return {
    canConsulter: can(user, module, 'consulter'),
    canAjouter: can(user, module, 'ajouter'),
    canModifier: can(user, module, 'modifier'),
    canArchiver: can(user, module, 'archiver'),
    canSupprimer: !!isAdmin, // suppression réservée au propriétaire
  };
}
